import quantile, {quantileIndex} from "./quantile.js";

export default function median(values, valueof) {
  return quantile(values, 0.5, valueof);
}

export function medianIndex(values, valueof) {
  return quantileIndex(values, 0.5, valueof);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/median.js
// module id = 421
// module chunks = 0